import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { ModalModule } from 'ngx-bootstrap/modal';
import { OwlModule } from 'ngx-owl-carousel';

import { ImageZoomComponent } from './image-zoom.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { ImageZoomViewerComponent } from './image-zoom-viewer.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    OwlModule,
    ModalModule,
    SwiperModule,
  ],
  exports: [
    ImageZoomComponent,
    ImageZoomViewerComponent,
  ],
  declarations: [
    ImageZoomComponent,
    ImageZoomViewerComponent,
  ],
})
export class ImageZoomModule {
}
